var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebm = function SvgWebm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.5 10.5 18 6h4.5zM4.5 13h13.6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 9,
    x: 2.1,
    y: 11,
    fill: "#1C7ABE",
    rx: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3.878 17.5-.999-3.49h.807l.577 2.425h.03l.637-2.426h.69l.636 2.43h.03l.579-2.43h.806L6.672 17.5h-.72l-.664-2.282H5.26L4.598 17.5zm4.236 0v-3.49h2.352v.608H8.852v.831h1.493v.609H8.852v.834h1.621v.608zm2.987 0v-3.49h1.398q.384 0 .642.113.257.114.387.317.13.201.13.464a.705.705 0 0 1-.307.612.9.9 0 0 1-.324.138v.034a.796.796 0 0 1 .658.404.86.86 0 0 1 .11.443q0 .278-.139.496a.93.93 0 0 1-.404.343 1.54 1.54 0 0 1-.66.126zm.738-.603h.602q.308 0 .45-.118a.4.4 0 0 0 .141-.317.47.47 0 0 0-.07-.256.5.5 0 0 0-.2-.174.7.7 0 0 0-.304-.063h-.619zm0-1.427h.547a.65.65 0 0 0 .27-.053.45.45 0 0 0 .187-.153.4.4 0 0 0 .07-.237.38.38 0 0 0-.135-.305q-.133-.117-.378-.116h-.561zm2.483-1.46h.91l.962 2.345h.04l.962-2.346h.91V17.5h-.715v-2.272h-.03l-.903 2.255h-.487l-.904-2.264h-.029V17.5h-.716z"
  })));
};
export default SvgWebm;